import React, { FC, useCallback, useMemo, useState } from 'react'
import form from 'styles/components/form.module.scss'
import { TextInput } from 'components/Form'
import { useNumberChangeEvent, useStringChangeEvent } from 'hooks/form'
import { Spacer } from 'components/Utility'
import { DeleteIconButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { openCautionModal } from 'reducks/modal/operations'

type Props = {
  deleteShoppingBagRow: (index: number) => void
  handleShoppingBags: (index: number, name: string, price: number) => void
  index: number
  name: string
  price: number
}

const ShoppingBagEditorRow: FC<Props> = (props) => {
  const { deleteShoppingBagRow, handleShoppingBags, index, name, price } = props

  const dispatch = useDispatch()

  const [_name, setName] = useState<string>(name)
  const [_price, setPrice] = useState<number>(price)

  const handleName = useStringChangeEvent(setName)
  const handlePrice = useNumberChangeEvent(setPrice)

  const openDeleteCaution = useCallback(() => {
    dispatch(
      openCautionModal(
        '削除する',
        'キャンセル',
        'この項目が削除されますが、よろしいでしょうか？\n\n既に事前予約でこのオプションを選択されている方がいる場合は、ご対応が必要になりますのでご注意ください',
        () => deleteShoppingBagRow(index),
        '項目の削除'
      )
    )
  }, [index, deleteShoppingBagRow])

  return (
    <div className={form.shoppingBag__row}>
      <TextInput
        disabled={false}
        onBlur={() => handleShoppingBags(index, _name, price)}
        onChange={handleName}
        placeholder={'サイズ'}
        required={false}
        size={'small'}
        type={'text'}
        value={_name}
      />
      <Spacer size={7} />
      <TextInput
        disabled={false}
        onBlur={() => handleShoppingBags(index, name, _price)}
        onChange={handlePrice}
        required={false}
        size={'small'}
        type={'text'}
        value={_price}
      />
      <Spacer size={21} />
      <DeleteIconButton onClick={openDeleteCaution} />
    </div>
  )
}

export default ShoppingBagEditorRow
